// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../public/Icons/calendarPrevIcon.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../public/Icons/calendarNextIcon.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateInput {
    width: 100% !important;
    background-color: transparent;
}

.DateInput_input {
    background-color: transparent;
    color: var(--primary-foreground) !important;
    padding: 9px 18px !important;
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 26px !important;
}

.DateInput_input__focused {
    border-bottom: unset !important;
}

.DateInput_screenReaderMessage {
    position: relative !important;
    height: 0px !important;
}

.SingleDatePickerInput {
    border-radius: 6px !important;
    border: 1px solid var(--primary-border) !important;
    display: flex;
    padding: 0 !important;
    background-color: var(--primary-input-bg);
}

.SingleDatePickerInput_clearDate {
    padding: 10px !important;
    margin: 0 !important;
    top: 0px !important;
    -webkit-transform: none !important;
    transform: none !important;
    -ms-transform: none !important;
    position: unset;
}

.SingleDatePickerInput_clearDate:focus,
.SingleDatePickerInput_clearDate:hover {
    background: transparent !important;
    outline: unset;
}

.adminCalenderCustomCloseIcon {
    width: 24px;
    height: 24px;
    display: inline-block;
}

.adminSingleDatePickerContainer .DateInput_input {
    border-radius: 6px !important;
    border-bottom: 0;
}

.adminSingleDatePickerContainer .DayPicker__withBorder {
    box-shadow: 0px 0px 16px 0px #120A0C0F !important;
    border-radius: 6px !important;
}

.adminSingleDatePickerContainer .DateInput_input::placeholder {
    color: var(--primary-placeholder-foreground) !important;
}

.adminSingleDatePickerContainer .SingleDatePicker_picker {
    background-color: var(--single-calendar-background) !important;
    z-index: 1032;
    top: 100% !important;
    border-radius: 6px;
}

.adminSingleDatePickerContainer .DateInput_fang {
    display: none !important;
}

.adminSingleDatePickerContainer .DayPicker__horizontal,
.adminSingleDatePickerContainer .CalendarMonthGrid,
.adminSingleDatePickerContainer .CalendarMonth {
    background-color: var(--single-calendar-background) !important;
}

.adminSingleDatePickerContainer .CalendarMonth_caption {
    color: var(--common-primary-black-foreground);
    font-size: 16px !important;
    line-height: 26px !important;
    font-weight: 400 !important;
    padding-top: 15px !important;
    padding-bottom: 44px !important;
}

.adminSingleDatePickerContainer .DayPickerNavigation_button,
.adminSingleDatePickerContainer .DayPickerNavigation_button:active {
    background-color: var(--common-primary-white-foreground) !important;
    border-radius: 50% !important;
    border: 1px solid var(--primary-border) !important;
    width: 100%;
    max-width: 36px;
    min-width: 36px;
    height: 36px;
    min-height: 36px;
    top: 10px !important;
}

.adminSingleDatePickerContainer .DayPickerNavigation_leftButton__horizontalDefault,
.adminSingleDatePickerContainer .DayPickerNavigation_rightButton__horizontalDefault {
    background-repeat: no-repeat !important;
    background-size: 24px !important;
    background-position: center !important;
}

.adminSingleDatePickerContainer .DayPickerNavigation_leftButton__horizontalDefault {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.adminSingleDatePickerContainer .DayPickerNavigation_rightButton__horizontalDefault {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}

.adminSingleDatePickerContainer .DayPickerNavigation_svg__horizontal,
.adminSingleDatePickerContainer .DayPickerNavigation_svg__horizontal_1 {
    display: none !important;
}

.CalendarDay__defaultCursor {
    cursor: not-allowed !important;
}

/* calendar color code */

.adminSingleDatePickerContainer .CalendarDay {
    border-radius: 50%;
    background: transparent;
    color: var(--common-primary-black-foreground);
    border: none !important;
}

.adminSingleDatePickerContainer .CalendarDay:hover {
    background: var(--primary-bg);
    color: var(--common-primary-white-foreground);
}

.adminSingleDatePickerContainer .CalendarDay__blocked_out_of_range,
.adminSingleDatePickerContainer .CalendarDay__blocked_out_of_range:hover {
    background: transparent !important;
    color: var(--single-calendar-outrange-foreground) !important;
}

.adminSingleDatePickerContainer .CalendarDay__blocked_calendar,
.adminSingleDatePickerContainer .CalendarDay__blocked_calendar:active,
.adminSingleDatePickerContainer .CalendarDay__blocked_calendar:hover {
    background: #cacccd !important;
    color: var(--common-primary-black-foreground) !important;
}

.adminSingleDatePickerContainer .CalendarDay__selected,
.adminSingleDatePickerContainer .CalendarDay__selected:active,
.adminSingleDatePickerContainer .CalendarDay__selected:hover {
    background: var(--primary-bg) !important;
    color: var(--common-primary-white-foreground) !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/reactDatesCalendar.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,2CAA2C;IAC3C,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,kDAAkD;IAClD,aAAa;IACb,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,kCAAkC;IAClC,0BAA0B;IAC1B,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;;IAEI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,6BAA6B;AACjC;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,8DAA8D;IAC9D,aAAa;IACb,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;IAGI,8DAA8D;AAClE;;AAEA;IACI,6CAA6C;IAC7C,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;;IAEI,mEAAmE;IACnE,6BAA6B;IAC7B,kDAAkD;IAClD,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,uCAAuC;IACvC,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,oEAAsE;AAC1E;;AAEA;IACI,oEAAsE;AAC1E;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA,wBAAwB;;AAExB;IACI,kBAAkB;IAClB,uBAAuB;IACvB,6CAA6C;IAC7C,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,6CAA6C;AACjD;;AAEA;;IAEI,kCAAkC;IAClC,4DAA4D;AAChE;;AAEA;;;IAGI,8BAA8B;IAC9B,wDAAwD;AAC5D;;AAEA;;;IAGI,wCAAwC;IACxC,wDAAwD;AAC5D","sourcesContent":[".DateInput {\n    width: 100% !important;\n    background-color: transparent;\n}\n\n.DateInput_input {\n    background-color: transparent;\n    color: var(--primary-foreground) !important;\n    padding: 9px 18px !important;\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    line-height: 26px !important;\n}\n\n.DateInput_input__focused {\n    border-bottom: unset !important;\n}\n\n.DateInput_screenReaderMessage {\n    position: relative !important;\n    height: 0px !important;\n}\n\n.SingleDatePickerInput {\n    border-radius: 6px !important;\n    border: 1px solid var(--primary-border) !important;\n    display: flex;\n    padding: 0 !important;\n    background-color: var(--primary-input-bg);\n}\n\n.SingleDatePickerInput_clearDate {\n    padding: 10px !important;\n    margin: 0 !important;\n    top: 0px !important;\n    -webkit-transform: none !important;\n    transform: none !important;\n    -ms-transform: none !important;\n    position: unset;\n}\n\n.SingleDatePickerInput_clearDate:focus,\n.SingleDatePickerInput_clearDate:hover {\n    background: transparent !important;\n    outline: unset;\n}\n\n.adminCalenderCustomCloseIcon {\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n}\n\n.adminSingleDatePickerContainer .DateInput_input {\n    border-radius: 6px !important;\n    border-bottom: 0;\n}\n\n.adminSingleDatePickerContainer .DayPicker__withBorder {\n    box-shadow: 0px 0px 16px 0px #120A0C0F !important;\n    border-radius: 6px !important;\n}\n\n.adminSingleDatePickerContainer .DateInput_input::placeholder {\n    color: var(--primary-placeholder-foreground) !important;\n}\n\n.adminSingleDatePickerContainer .SingleDatePicker_picker {\n    background-color: var(--single-calendar-background) !important;\n    z-index: 1032;\n    top: 100% !important;\n    border-radius: 6px;\n}\n\n.adminSingleDatePickerContainer .DateInput_fang {\n    display: none !important;\n}\n\n.adminSingleDatePickerContainer .DayPicker__horizontal,\n.adminSingleDatePickerContainer .CalendarMonthGrid,\n.adminSingleDatePickerContainer .CalendarMonth {\n    background-color: var(--single-calendar-background) !important;\n}\n\n.adminSingleDatePickerContainer .CalendarMonth_caption {\n    color: var(--common-primary-black-foreground);\n    font-size: 16px !important;\n    line-height: 26px !important;\n    font-weight: 400 !important;\n    padding-top: 15px !important;\n    padding-bottom: 44px !important;\n}\n\n.adminSingleDatePickerContainer .DayPickerNavigation_button,\n.adminSingleDatePickerContainer .DayPickerNavigation_button:active {\n    background-color: var(--common-primary-white-foreground) !important;\n    border-radius: 50% !important;\n    border: 1px solid var(--primary-border) !important;\n    width: 100%;\n    max-width: 36px;\n    min-width: 36px;\n    height: 36px;\n    min-height: 36px;\n    top: 10px !important;\n}\n\n.adminSingleDatePickerContainer .DayPickerNavigation_leftButton__horizontalDefault,\n.adminSingleDatePickerContainer .DayPickerNavigation_rightButton__horizontalDefault {\n    background-repeat: no-repeat !important;\n    background-size: 24px !important;\n    background-position: center !important;\n}\n\n.adminSingleDatePickerContainer .DayPickerNavigation_leftButton__horizontalDefault {\n    background-image: url('/public/Icons/calendarPrevIcon.svg') !important;\n}\n\n.adminSingleDatePickerContainer .DayPickerNavigation_rightButton__horizontalDefault {\n    background-image: url('/public/Icons/calendarNextIcon.svg') !important;\n}\n\n.adminSingleDatePickerContainer .DayPickerNavigation_svg__horizontal,\n.adminSingleDatePickerContainer .DayPickerNavigation_svg__horizontal_1 {\n    display: none !important;\n}\n\n.CalendarDay__defaultCursor {\n    cursor: not-allowed !important;\n}\n\n/* calendar color code */\n\n.adminSingleDatePickerContainer .CalendarDay {\n    border-radius: 50%;\n    background: transparent;\n    color: var(--common-primary-black-foreground);\n    border: none !important;\n}\n\n.adminSingleDatePickerContainer .CalendarDay:hover {\n    background: var(--primary-bg);\n    color: var(--common-primary-white-foreground);\n}\n\n.adminSingleDatePickerContainer .CalendarDay__blocked_out_of_range,\n.adminSingleDatePickerContainer .CalendarDay__blocked_out_of_range:hover {\n    background: transparent !important;\n    color: var(--single-calendar-outrange-foreground) !important;\n}\n\n.adminSingleDatePickerContainer .CalendarDay__blocked_calendar,\n.adminSingleDatePickerContainer .CalendarDay__blocked_calendar:active,\n.adminSingleDatePickerContainer .CalendarDay__blocked_calendar:hover {\n    background: #cacccd !important;\n    color: var(--common-primary-black-foreground) !important;\n}\n\n.adminSingleDatePickerContainer .CalendarDay__selected,\n.adminSingleDatePickerContainer .CalendarDay__selected:active,\n.adminSingleDatePickerContainer .CalendarDay__selected:hover {\n    background: var(--primary-bg) !important;\n    color: var(--common-primary-white-foreground) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
